module.exports = __webpack_public_path__ + "img/brandMgt.b2090d10.svg";